import React from 'react';
import { DocumentResponse } from '../../types/DocumentResponse';
import { KnowledgeBaseItemResponse } from '../../types/KnowledgeBaseItemResponse';

interface DocumentPreviewProps {
  handleRowClick: (
    document: DocumentResponse | KnowledgeBaseItemResponse
  ) => Promise<void>;
  children: React.ReactNode;
}

function DocumentPreview({
  handleRowClick,
  children
}: DocumentPreviewProps): React.ReactElement {
  const onRowClick = async (
    document: DocumentResponse | KnowledgeBaseItemResponse
  ): Promise<void> => {
    try {
      await handleRowClick(document);
    } catch (error) {
      console.error('Error handling document preview:', error);
    }
  };

  return (
    <>
      {React.cloneElement(children as React.ReactElement, {
        handleRowClick: onRowClick
      })}
    </>
  );
}

export default DocumentPreview;
